<template>
    <div class="center w-full pl-0 pr-0 xl:pl-4 xl:pr-4 lg:pl-3 lg:pr-3">
		<div class="flex w-full justify-content-center align-items-center pt-0 pb-0 xl:pt-4 xl:pb-8 lg:pt-3 lg:pb-5">
			<div class="flex flex-column w-full surface-0 xl:border-round-xl lg:border-round-xl">
                <div class="w-full flex flex-column pt-4 px-3 pb-0 xl:px-6 lg:px-5 md:px-4">            
                    <span class="flex text-900 font-medium mb-4 xl:mb-6 text-3xl xl:text-6xl lg:text-5xl md:text-4xl">
                        {{header[lang].name}}
                    </span>
                    <div class="w-full flex flex-row mb-4 align-items-end gap-3">
                        <div class="flex flex-column align-items-end">
                            <span class="flex text-600 mb-2 text-sm">
                                Выберите период:
                            </span>
                            <Dropdown id='date' v-model="date" :options="date_list" :loading="loading" option-label="name" class='w-full border-round-lg' placeholder="Выберите дату" />
                        </div>
                        <div class="flex align-items-end">
                            <Button label="Обновить" @click='refresh()' :loading="loading" class="flex surface-400 border-400 text-900 border-round-lg" :disabled="!merchant" icon="pi pi-refresh" iconPos="right" size="small"/>
                        </div> 
                    </div>
                </div>
                <div class="w-full flex flex-column pb-3 px-0 xl:px-6 xl:pb-6 lg:px-5 lg:pb-5 md:px-4 md:pb-4">            
                    <Tabs :value="active">
                        <TabList>
                            <Tab :value="0">
                                <span class="font-medium text-sm xl:text-base lg:text-base">Карты</span>
                            </Tab>
                            <Tab :value="1">
                                <span class="font-medium text-sm xl:text-base lg:text-base">Ликвидность</span>
                            </Tab>
                            <Tab :value="2">
                                <span class="font-medium text-sm xl:text-base lg:text-base">Статистика</span>
                            </Tab>
                        </TabList>
                        <TabPanels>
                            <TabPanel :value="0">
                                <CardList :cards="cards" :editing="true"/>
                            </TabPanel>
                            <TabPanel :value="1">
                                <Liquidity :data="merchant" :merchant_id="merchant_id" />
                            </TabPanel>
                            <TabPanel :value="2">
                                <Balance :data="merchant" :loading="loading" />
                                <Statistics :data="merchant" :loading="loading" />
                            </TabPanel>
                        </TabPanels>
                    </Tabs>
                </div>
			</div>
		</div>
	</div>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import CardList from '@/components/merchant/CardList.vue'
import Balance from '@/components/merchant/Balance.vue'
import Statistics from '@/components/merchant/Statistics.vue'
import Liquidity from '@/components/merchant/Liquidity.vue'

export default {
    data() {
        return {
            header: {
                en: {name: "Statistics"} ,
                ru: {name: "Cтатистика"} ,
            }, 
            active: 0,
            merchant: null,
            merchant_id: null,
            wallet_id: null,
            cards: [],
            date: {
                name: 'месяц',
                val: 30
            },
            date_list: [
                {
                    name: 'сегодня',
                    val: 1
                },
                {
                    name: 'неделя',
                    val: 7
                },
                {
                    name: 'месяц',
                    val: 30
                },
                {
                    name: 'год',
                    val: 365
                },
            ],
            loading: false,
        }
    },
    components: {
        Balance,
        Statistics,
        Liquidity,
        CardList,
    },
    methods: {
        async loadMerchant() {
            this.loading = true
            const merchat_data = await this.connect.get_merchant(this.date.val).then(res=>res)
            if(merchat_data.result) {
                this.merchant = merchat_data.data
                this.cards = merchat_data.data.cards
                this.merchant_id = merchat_data.data.id
            }
            this.loading = false
        },
        async refresh(){
            this.merchant = null
            this.cards = []
            this.loadMerchant()
        },
    },
    computed: {
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        isDarkTheme() { return this.$store.getters.StateDarkTheme },
    },
    watch: {
        async date() {
            this.loadMerchant()
        }
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
    async mounted(){
        await this.loadMerchant()
        this.helper.SetTgAppHeadColor('white', this.isDarkTheme)
    },
}
</script>